// Контракт zod-схем для delivery (Task 5 плана 2026-05-01-packing-shop-warehouse-delivery.md).
// Схемы написаны заранее (часть TDD-контракта в delivery.test.ts).
// Числовые лимиты вынесены в константы, чтобы тест и схема ссылались на одно
// и то же значение.
import { z } from "zod";
// 5 MB в base64 ≈ 5 * 1024 * 1024 * 4 / 3 = 6_990_507 символов. Берём чуть с
// запасом — ровно 7 MB символьного предела достаточно, чтобы 5 MB бинарника
// прошёл, а злонамеренный 7 MB+ base64 — нет.
export const COURIER_SCREENSHOT_MAX_B64_CHARS = Math.ceil((5 * 1024 * 1024 * 4) / 3);
export const COURIER_MAX_SCREENSHOTS = 4;
export const COURIER_MANUAL_TEXT_MIN = 30;
export const COURIER_MANUAL_TEXT_MAX = 2000;
const screenshotsSchema = z
    .array(z.string().min(1).max(COURIER_SCREENSHOT_MAX_B64_CHARS))
    .max(COURIER_MAX_SCREENSHOTS);
export const courierIntakeSchema = z
    .object({
    mode: z.enum(["screenshots", "manual"]),
    screenshots: screenshotsSchema.optional(),
    manualText: z.string().max(COURIER_MANUAL_TEXT_MAX).optional(),
})
    .superRefine((val, ctx) => {
    if (val.mode === "screenshots") {
        if (!val.screenshots || val.screenshots.length === 0) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "mode=screenshots требует хотя бы один скриншот",
                path: ["screenshots"],
            });
        }
    }
    else if (val.mode === "manual") {
        if (!val.manualText || val.manualText.trim().length < COURIER_MANUAL_TEXT_MIN) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `mode=manual требует manualText не менее ${COURIER_MANUAL_TEXT_MIN} символов`,
                path: ["manualText"],
            });
        }
    }
});
//# sourceMappingURL=schemas.js.map